import { RootState } from "../../../../../redux/store";
import { useSelector } from "react-redux";
import Link from "next/link";
import useUser from "../../../../../hooks/user/useUser";
import { ListingType } from "../../../../../enums/listing/TitleTypes";
import { SecondaryButton } from "../../../../global/buttons/material/secondaryButton/SecondaryButton";
import { Check } from "@mui/icons-material";
import {
  ListingModalOptionProvider,
  ListingModalPlanContentWrapper,
  ListingModalPlanOptionsSubtitle,
  ListingModalPlanOptionsTitle,
  ListingModalPlanOptionsWrapper,
  ListingModalPlanRedirect,
} from "../listingModalPlanOptions";
import { ListingModalOneTimeOption } from "../listingModalPlanOptions/ListingModalOneTimeOption";
import { useGetDataForSwapOneTimeModal } from "../../../../../hooks/trainingPlan/useGetDataForSwapOneTimeModal";
import { useSetSubscriptionFromPrice } from "../../../../../hooks/trainingPlan/useSetSubscriptionFromPrice";
import { ListingSwapOption } from "./ListingSwapOption";
import { useOnetimeBuyVerifyPurchase } from "../../../../../hooks/trainingPlan";

export const ListingModalSwapOneTime = () => {
  const { user } = useUser();
  const currentListing = useSelector(
    (state: RootState) => state.trainingPlan.listingData,
  );
  const listingType = useSelector(
    (state: RootState) => state.trainingPlan.listingType,
  );
  const isPurchased = useOnetimeBuyVerifyPurchase({
    currentListing: currentListing,
  });

  const listingIsAssessment = listingType !== ListingType.ASSESSMENT;
  const subtitle =
    currentListing?.price === 0 ? "Unlock for free" : "Get started";

  useGetDataForSwapOneTimeModal();
  useSetSubscriptionFromPrice();

  return (
    <ListingModalPlanOptionsWrapper>
      <ListingModalPlanOptionsTitle>
        Included with your membership{" "}
      </ListingModalPlanOptionsTitle>

      {!isPurchased && (
        <ListingModalPlanOptionsSubtitle>
          {subtitle}
        </ListingModalPlanOptionsSubtitle>
      )}

      <ListingModalPlanContentWrapper>
        {isPurchased && (
          <SecondaryButton startIcon={<Check />} title="In your library" />
        )}
        {listingIsAssessment &&
          user.subscription_data.subscriptionPlan.type !== "gold" && (
            <ListingModalOptionProvider>
              <ListingSwapOption />
            </ListingModalOptionProvider>
          )}
        <ListingModalOptionProvider>
          <ListingModalOneTimeOption
            useSecondaryButton={currentListing.price !== 0}
          />
        </ListingModalOptionProvider>
      </ListingModalPlanContentWrapper>

      <Link href={"/payment"}>
        <ListingModalPlanRedirect>
          Upgrade Your Membership
        </ListingModalPlanRedirect>
      </Link>
    </ListingModalPlanOptionsWrapper>
  );
};
